// Angular Imports
import { NgModule, LOCALE_ID } from '@angular/core'
import { CommonModule, registerLocaleData } from '@angular/common'
import { BrowserModule } from '@angular/platform-browser'
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import localeEs from '@angular/common/locales/es'
// This Module Imports
import { AppRoutingModule } from './app-routing.module'
import { AppComponent } from './app.component'
// Shared Imports
import { EnvironmentDecoratorComponent, SecureImageComponent } from '@shared/components'
import { AddTokenAndRefreshInterceptor } from '@shared/interceptors'
import { MaterialModule } from '@shared/modules'
import { NgcCookieConsentModule, NgcCookieConsentConfig } from 'ngx-cookieconsent'

const sharedComponents = [EnvironmentDecoratorComponent, SecureImageComponent]
const sharedModules = [MaterialModule]
const cookieConfig: NgcCookieConsentConfig = {
	cookie: {
		domain: window.location.hostname,
	},
	palette: {
		popup: {
			background: '#000',
		},
		button: {
			background: '#f1d600',
		},
	},
	theme: 'classic',
	type: 'info',
	content: {
		message:
			'Vemo utiliza cookies propias y de terceros que permiten mejorar la usabilidad de navegación y recopilar información. No se utilizarán las cookies para recoger información de carácter personal. Solo se instalarán las cookies no esenciales para la navegación si acepta esta característica.',
		link: '',
		dismiss: 'Aceptar',
	},
}

registerLocaleData(localeEs)

@NgModule({
	declarations: [AppComponent],
	imports: [
		CommonModule,
		BrowserModule,
		BrowserAnimationsModule,
		HttpClientModule,
		AppRoutingModule,
		// Shared
		...sharedComponents,
		...sharedModules,
		NgcCookieConsentModule.forRoot(cookieConfig),
	],
	providers: [
		// We configurate the locale to use the Spanish language
		{ provide: LOCALE_ID, useValue: 'es' },
		{
			provide: HTTP_INTERCEPTORS,
			useClass: AddTokenAndRefreshInterceptor,
			multi: true,
		},
	],
	bootstrap: [AppComponent],
})
export class AppModule {}
